import { gql } from '@apollo/client'

export const POOL_CASES_QUERY = gql`
  query poolProcessings(
    $poolSlug: String!
    $sortBy: PoolProcessingsSort
    $filter: PoolProcessingsFilter
    $page: Int
    $limit: Int
    $isAdmin: Boolean = false
  ) {
    poolProcessings(
      poolSlug: $poolSlug
      sortBy: $sortBy
      filter: $filter
      page: $page
      limit: $limit
    ) {
      metadata {
        totalCount
        currentPage
      }
      collection {
        id
        fileNumber
        poolId
        closingType {
          title
        }
        invoice {
          id
          invoiceNo
          sentAt
        }
        income
        additionalIncome
        additionalIncomeComments
        invoiceSettlementComments
        costsSettledWithRsvAt
        rsvBillable
        rsvNonBillableReason
        additionalCost
        paymentStatus
        m2Case {
          priority
          forwardedCase
          legalAdvice
          coverageScope
          id
          settlementComments @include(if: $isAdmin)
          customerRating @include(if: $isAdmin)
          source
          handoverType
          caseState
          commentsPolicyholder
          commentsLegalAdvice
          insurance {
            title
          }
          hint
          creator {
            id
            name
          }
          creatorComments
          project {
            title
            callCenterLegalAdvice
            collisionDetectionEnabled
            reactionTimeInMinutes
          }
          policyholder {
            salutation
            lastname
            firstname
            birthDate
            company
            street
            houseNumber
            postalCode
            place
            phoneNumber
            mobileNumber
            email
            comments
            communicationViaCustomerPortal
            casesCount
            policyNumber
            cases {
              id
              claimNumber
              assignedToM2At
            }
          }
          conflictPartner {
            salutation
            lastname
            firstname
            birthDate
            company
            street
            houseNumber
            postalCode
            place
            phoneNumber
            mobileNumber
            email
            comments
          }
          contactPerson {
            id
            salutation
            lastname
            firstname
            phoneNumber
            mobileNumber
            email
            relationToPolicyholder
          }
          claimNumber
          conflictPartnerFileNumber
          claimDate
          assignedToM2At
          m2LegalArea {
            title
          }
          rsvLegalArea {
            title
          }
          comments
          cost @include(if: $isAdmin)
          additionalCost @include(if: $isAdmin)
          customerComments
          disputeValue
          deductible
          deductibleAmount
          costsSettledWithRsvAt @include(if: $isAdmin)
          evaluatedDailyAt
          evaluatedMonthlyAt
          rsvStatus
          statusReportSentAt @include(if: $isAdmin)
        }
        coverage
        agentId
        agent {
          name
          role @include(if: $isAdmin)
        }
        assignedFromId
        assignedFrom {
          name
          id
        }
        assignedAt
        acceptedAt
        canBeginAt
        processingStep
        processingState
        firstCallAt
        forwardedToRightmartAt
        closedAt
        closedByM2
        processingComments
        intendedProcessingType {
          title
          category
        }
        assignedProcessingType {
          title
          category
        }
        actualProcessingType {
          id
          title
          category
          callCenterLegalAdvice
        }
        documentsWereSent
        settlementRate
        settlementTypeId
        settlementType {
          title
        }
        closingTypeId
        closingType {
          title
        }
        result
        closedByRsv
        feedbackRsvAt
        costsSettledWithOperatorAt @include(if: $isAdmin)
        cost @include(if: $isAdmin)
        additionalCost @include(if: $isAdmin)
        costsCoveredByKp @include(if: $isAdmin)
        receivedPayment @include(if: $isAdmin)
        settlementComments @include(if: $isAdmin)
        closingComments
        coverage
        policyholderContactedAt
        coverageRequestedAt
        forwardedToRightmartAt
        coverageComments
        feedbackRsvAt
        date1
        date2
        statusReportSentAt @include(if: $isAdmin)
        lastActionAt
        nextTaskAt
        nextTaskComment
        canBeginAt
        firstCallDelayed
        goalPolicyholderWants
        goalPolicyholderSolutions
        goalConflictPartnerWants
        goalConflictPartnerSolutions
      }
    }
  }
`
